import type { JSX } from 'react';
import React from 'react';
import { Redirect, Switch } from 'react-router-dom';

import { useFlags } from '@feathr/report_components';

import ReportsAudienceEngagementPage from '../ReportsAudienceEngagementPage';
import ReportsConversionsDashboardPage from '../ReportsConversionsDashboardPage';
import ReportsConversionsGoalManagerPage from '../ReportsConversionsGoalManagerPage';
import GoalDetailPage from '../ReportsConversionsGoalManagerPage/GoalDetailPage';
import RouteWithPermissions from './RouteWithPermissions';

function ReportsRoutes(): JSX.Element {
  const { showAccountReports } = useFlags();

  return (
    <Switch>
      <Redirect
        exact={true}
        from={'/:accountId/reports'}
        to={'/:accountId/reports/audience-engagement'}
      />
      <RouteWithPermissions
        condition={showAccountReports}
        exact={true}
        path={'/:accountId/reports/audience-engagement'}
      >
        <ReportsAudienceEngagementPage />
      </RouteWithPermissions>
      <Redirect
        exact={true}
        from={'/:accountId/reports/conversions'}
        to={'/:accountId/reports/conversions/dashboard'}
      />
      <RouteWithPermissions
        condition={showAccountReports}
        exact={true}
        path={'/:accountId/reports/conversions/dashboard'}
      >
        <ReportsConversionsDashboardPage />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showAccountReports}
        exact={true}
        path={'/:accountId/reports/conversions/goal-manager'}
      >
        <ReportsConversionsGoalManagerPage />
      </RouteWithPermissions>
      <RouteWithPermissions
        condition={showAccountReports}
        exact={true}
        path={'/:accountId/reports/conversions/goal-manager/:goalId'}
      >
        <GoalDetailPage />
      </RouteWithPermissions>
    </Switch>
  );
}

export default ReportsRoutes;
